export default {
  data(){
    return {
      submitButtonText            : '投入',
      isLoadingSubmitButton       : false,
      isDisableSubmitButton       : false,
      additionalSubmitButtonClass : {
        'is-loading'  : false
      },
      
      cancelButtonText            : '中断',
      isLoadingCancelButton       : false,
      isDisableCancelButton       : false,
      additionalCancelButtonClass : {
        'is-loading'  : false
      }
    };
  },

  computed : {
    isEditorLoading(){
      return this.$store.state.parkNote.isEditorLoading;
    }
  },

  watch: {
    isLoadingSubmitButton(value){
      this.isDisableSubmitButton = value;
      this.additionalSubmitButtonClass['is-loading'] = value;
    },

    isLoadingCancelButton(value){
      this.isDisableCancelButton = value;
      this.additionalCancelButtonClass['is-loading'] = value;
    },

    isEditorLoading(value){
      this.isDisableSubmitButton = value;
      this.isDisableCancelButton = value;
    },

    editorBehaviour(value){
      switch(value){
        case 'new':
          this.submitButtonText = '投入';
        break;

        case 'edit':
          this.submitButtonText = '編纂';
        break;
      }
    }
  },

  methods : {
    submitValidation(){
      if(this.titleData.trim() === '' || this.editorData === null || this.editorData.onlyText.trim() === ''){
        this.showShouldInputTitleAndBodyAlert();

        return false;
      }else if(this.titleData.trim().length > this.titleLimitationLength){
        this.showTitleTextOveredAlert();

        return false;
      }else{
        return true;
      }
    },

    async handleClickSubmit(){
      if(this.isDisableSubmitButton) return;
      if( !this.submitValidation() ) return;

      this.isLoadingSubmitButton = true;
      this.isDisableCancelButton = true;
      
      await this.executeSubmitButton();
    },

    async handleClickCancel(){
      if(this.isDisableCancelButton) return;

      this.isLoadingCancelButton = true;
      this.isDisableSubmitButton = true;

      await this.executeCancelButton();

      this.handleCloseModal();

      this.isLoadingCancelButton = false;
      this.isDisableSubmitButton = false;
    }
  }
}